import type {
  FormattedAdminUser,
  FormattedMemberNotes,
  FormattedMemberNotesResponse,
  MemberNoteAdminUser,
  MemberNotesResponse
} from '@library/types/members/memberNotes';
import {
  getDateTime,
  getFormattedDateTime
} from '@bo-utils/members/memberCommon';
import { GET_MEMBER_NOTES_PER_PAGE_COUNT } from '@bo-constants/member/memberNotes';

export const formattedAdminUser = (
  adminUser?: MemberNoteAdminUser
): FormattedAdminUser | undefined => {
  if (!adminUser) {
    return undefined;
  }

  const { email, first_name: firstName, last_name: lastName } = adminUser;

  const name = firstName && lastName ? `${firstName} ${lastName}` : '';
  const initials = email ? email[0] : '';

  return {
    email,
    initials,
    name
  };
};

export const transformMemberNotes = ({
  response,
  page,
  perPage
}: {
  response: MemberNotesResponse | undefined;
  page: number;
  perPage: number;
}): FormattedMemberNotesResponse | undefined => {
  if (!response) {
    return undefined;
  }

  const { data, included } = response;

  const formattedMemberNotes: FormattedMemberNotes = data?.map((note) => {
    const { attributes, id, relationships } = note;

    const userRelId = relationships.author.data.id;

    const userRelationship = included.find(
      (incl) => incl.id === userRelId && incl.type === 'admin_user'
    )?.attributes;

    const adminUser = formattedAdminUser(userRelationship);

    const createdDateTime = getFormattedDateTime({
      dateTime: getDateTime({ dateString: attributes.created_at })
    });

    return {
      adminUser,
      body: attributes.body,
      createdDateTime,
      id
    };
  });

  const totalPages =
    formattedMemberNotes.length < (perPage || GET_MEMBER_NOTES_PER_PAGE_COUNT)
      ? page
      : page + 1;

  return {
    currentPage: page,
    data: formattedMemberNotes,
    totalPages
  };
};
